var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification-button",class:{ 'is-active': _vm.$store.state.ui.isNewNotifications },on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }